import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedNetworkId: null,
};

const networkSlice = createSlice({
  name: "network",
  initialState,
  reducers: {
    setSelectedNetworkId: (state, action) => {
      state.selectedNetworkId = action.payload;
    },
  },
});

export const { setSelectedNetworkId } = networkSlice.actions;
export default networkSlice.reducer;
